export default __webpack_public_path__ + "static/media/1.460c816e.png";